import React from 'react';
import { scheduleMeta } from '../data/content';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { ClockIcon, SparkleIcon } from './icons/GoldIcons';
export function Schedule() {
  const {
    t
  } = useLanguage();
  return <section id="horario" className="w-full bg-ink-800 py-24 sm:py-32" data-id="element-289" data-mp="w4jg3ymhudvz">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-290" data-mp="w5uhxswdpbkg">
        <SectionHeading eyebrow={t.schedule.eyebrow} title={t.schedule.title} data-id="element-291" data-mp="3umxerffcdn62" />

        <p className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-gold-deep/45 bg-gold-deep/10 px-5 py-2 text-[12px] uppercase tracking-[0.16em] text-gold-soft" data-id="element-292" data-mp="3ej99u8fmqqh">
          <SparkleIcon className="h-3.5 w-3.5 shrink-0 text-gold-bright" data-id="element-293" data-mp="dd8otgcuvz3k" />
          {t.schedule.walkIn}
        </p>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-[1.3fr_1fr] lg:gap-14" data-id="element-294" data-mp="1judr0an95sdl">
          <ul className="divide-y divide-gold-deep/15" data-id="element-295" data-mp="1os5rht1yqmte">
            {t.schedule.days.map((day, index) => {
            const meta = scheduleMeta[index] ?? {};
            return <li key={day.day} className={`flex items-center justify-between gap-6 py-4 ${meta.closed ? 'opacity-45' : ''}`} data-id="element-296" data-mp="1d1nmxi5by0vl" data-mpi={index}>
                  <span className="flex items-center gap-3" data-id="element-297" data-mp="142trvw7ndik5">
                    <span className={`text-base tracking-wide ${meta.featured ? 'text-gold-bright' : 'text-neutral-200'}`} data-id="element-298" data-mp="1456ambl8bwy9">
                      {day.day}
                    </span>
                    {day.note ? <span className="hidden rounded-full border border-gold-deep/40 px-3 py-1 text-[10px] uppercase tracking-[0.18em] text-gold-muted sm:inline-block" data-id="element-299" data-mp="u78njrf3w678">
                        {day.note}
                      </span> : null}
                  </span>
                  <span className={`text-sm tabular-nums ${meta.featured ? 'text-gold-soft' : 'text-neutral-400'}`} data-id="element-300" data-mp="gf268207vt67">
                    {day.hours}
                  </span>
                </li>;
          })}
          </ul>

          <aside className="rounded-3xl border border-gold-deep/30 bg-[radial-gradient(ellipse_at_top,rgba(212,168,87,0.13),transparent_70%)] p-8" data-id="element-301" data-mp="6gcyh221bp3o">
            <ClockIcon className="h-7 w-7 text-gold-soft" data-id="element-302" data-mp="1rld2uvxhsc6" />
            <p className="mt-6 leading-relaxed text-neutral-300" data-id="element-303" data-mp="1oz7h0sllmwl">
              {t.schedule.friday.lead}
              <span className="text-gold-ivory" data-id="element-304" data-mp="3j1jr2bzwfdhq">{t.schedule.friday.accent}</span>
              {t.schedule.friday.rest}
            </p>
            <p className="mt-4 leading-relaxed text-neutral-300" data-id="element-305" data-mp="fhx934vmwb8l">
              {t.schedule.saturday.lead}
              <span className="text-gold-ivory" data-id="element-306" data-mp="khtbx0slhwmk">{t.schedule.saturday.accent}</span>
              {t.schedule.saturday.rest}
            </p>
            <p className="mt-8 flex items-start gap-3 border-t border-gold-deep/25 pt-6 text-sm text-neutral-400" data-id="element-307" data-mp="5sdp1vw6qbc5">
              <SparkleIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-muted" data-id="element-308" data-mp="apdss05kb203" />
              {t.schedule.privateParties}
            </p>
          </aside>
        </div>
      </div>
    </section>;
}